

export interface ICustomHoliday {
  customHolidayID: number;
  name: string;
  date: string;
  everyYear: boolean;
  description: string;
  editData: ICustomHoliday | null;
  validItem: any;
}


export class CCustomHoliday implements ICustomHoliday {
  public customHolidayID = 0;
  public name = '';
  public date = todayString();
  public description = '';
  public everyYear = false;
  public editData = null;
  public validItem = null;
}

const todayString = (): string => {
  const now = new Date();
  return now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate();
};
